import type { EmblaCarouselType } from 'embla-carousel';

export const LockDragPlugin = () => {
  let isLocked = false;
  let emblaApi: EmblaCarouselType | null = null;

  const pointerDownHandler = (event: PointerEvent) => {
    if (isLocked) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  return {
    name: 'LockDragPlugin',
    options: {},

    lock: () => {
      isLocked = true;
    },

    unlock: () => {
      isLocked = false;
    },

    init: (embla: EmblaCarouselType) => {
      emblaApi = embla;
      embla.rootNode().addEventListener('pointerdown', pointerDownHandler, {
        passive: false,
      });
    },

    destroy: () => {
      emblaApi?.rootNode().removeEventListener('pointerdown', pointerDownHandler);
    },
  };
};
